module.exports = __webpack_public_path__ + "static/media/warning-yellow.eab7f610.svg";